<template>
  <v-app>
    <v-app-bar src="photos/Bjorn_DSC_6243_NARVAL1_web.jpg" app>
      <v-toolbar-title class="headline text-uppercase" style="color:white;">
        <span>EUREC<sup>4</sup>A</span>
        <span class="font-weight-light">&nbsp;Operational Center</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn text href="http://eurec4a.eu/" target="_blank">
        <span class="mr-2" style="color:white">EUREC<sup>4</sup>A website</span>
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer permanent app v-bind:width="350">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title">
            <img :src="require('@/assets/logo_eurec4a.png')" height="150px" />
          </v-list-item-title>
          <!--
          <v-list-item-subtitle>
            subtext
          </v-list-item-subtitle>-->
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-treeview
        v-model="tree"
        :open="open"
        :items="items"
        activatable
        dense
        item-key="name"
        open-on-click
      >
        <template v-slot:label="{ item, open }">
          <v-icon v-if="!item.file">
            {{ open ? "mdi-folder-open" : "mdi-folder" }}
          </v-icon>
          <v-icon v-else>
            {{ files[item.file] }}
          </v-icon>
          <v-label v-if="item.value" @click="openContent(item.value)">
            {{ item.name }}
          </v-label>
          <v-label v-else>
            {{ item.name }}
          </v-label>
          <v-label v-if="item.locked">
            (no data)
          </v-label>
        </template>
      </v-treeview>
    </v-navigation-drawer>

    <v-content>
      <MainFrame :content="content" />
    </v-content>
  </v-app>
</template>

<script>
import MainFrame from "./components/MainFrame";

export default {
  name: "App",
  components: {
    MainFrame
  },
  data: () => ({
    content: "home",
    open: ["public"],
    files: {
      html: "mdi-language-html5",
      js: "mdi-nodejs",
      json: "mdi-json",
      md: "mdi-markdown",
      pdf: "mdi-file-pdf",
      png: "mdi-file-image",
      txt: "mdi-file-multiple-outline",
      model: "mdi-globe-model",
      database: "mdi-database",
      image: "mdi-image-outline",
      images: "mdi-image-multiple-outline",
      news: "mdi-newspaper-variant-multiple-outline",
      dolly: "mdi-dolly",
      obs: "mdi-file-eye-outline",
      satellite: "mdi-satellite-variant",
      web: "mdi-web",
      radar: "mdi-satellite-uplink",
      ship: "mdi-ferry",
      plane: "mdi-airplane",
      map: "mdi-map-outline",
      animation: "mdi-animation-play",
      home: "mdi-home-modern",
      home2: "mdi-home",
      gps: "mdi-crosshairs-gps",
      saildrone: "mdi-sail-boat",
      drone: "mdi-drone",
      buoy: "mdi-lifebuoy",
      airballoon: "mdi-airballoon",
      balloon: "mdi-balloon",
      path: "mdi-map-marker-path",
      movies: "mdi-movie-open-outline",
      apps: "mdi-apps",
      toolbox: "mdi-toolbox-outline",
      gitlab: "mdi-gitlab",
      github: "mdi-github",
      application: "mdi-application",
      presentation: "mdi-presentation-play",
      school: "mdi-school-outline"
    },
    tree: [],
    items: [
      {
        name: "Home",
        file: "home2",
        value: "home"
      } /*
      {
        name: "Live platform positions",
        file: "gps",
        value: "live"
      },*/,
      {
        name: "Observations",
        file: "obs",
        children: [
          {
            name: "Satellites",
            file: "satellite",
            children: [
              {
                name: "GOES-E",
                file: "image",
                value: "obs-sat-goese-ir62"
              },
              {
                name: "CALIPSO - LIDAR",
                children: [
                  {
                    name: "Data",
                    file: "database",
                    value: "obs-sat-calipso-data"
                  },
                  {
                    name: "Quicklooks",
                    file: "images",
                    value: "obs-sat-calipso"
                  }
                ]
              },
              {
                name: "Terra - ASTER",
                children: [
                  {
                    name: "Data",
                    file: "database",
                    value: "obs-sat-aster-data"
                  },
                  {
                    name: "Quicklooks",
                    file: "image",
                    value: "obs-sat-aster"
                  }
                ]
              },
              {
                name: "Terra - MODIS",
                file: "image",
                value: "obs-sat-modis"
              },
              {
                name: "Ocean",
                children: [
                  {
                    name: "SMAP Data",
                    file: "image",
                    value: "obs-sat-smap"
                  },
                  {
                    name: "MUR Data",
                    file: "image",
                    value: "obs-sat-mur"
                  },
                  {
                    name: "SMOS Data",
                    file: "image",
                    value: "obs-sat-smos"
                  },
                  {
                    name: "CLS Data",
                    file: "image",
                    value: "obs-sat-cls"
                  },
                  {
                    name: "Maps SAT Forecast Ocean",
                    file: "images",
                    value: "rv-atalante-maps-sat"
                  }
                ]
              },
              {
                name: "GOES-E animations",
                file: "web",
                value: "obs-sat-goese-anim"
              },
              {
                name: "IXION: Satellite Pass Predictions",
                file: "web",
                value: "ixion"
              },
              {
                name: "NASA WorldView",
                file: "web",
                value: "nasa"
              }
            ]
          },
          {
            name: "Aircraft",
            file: "plane",
            children: [
              {
                name: "ATR-42",
                file: "plane",
                children: [
                  {
                    name: "Reports",
                    file: "txt",
                    value: "atr-reports"
                  },
                  {
                    name: "SAFIRE",
                    value: "safire",
                    children: [
                      {
                        name: "Flights core data",
                        file: "images",
                        value: "safire-flights"
                      },
                      {
                        name: "Radiometer CLIMAT-CE332",
                        file: "database",
                        value: "safire-radiometer"
                      }
                    ]
                  },
                  {
                    name: "ALIAS Lidar",
                    children: [
                      {
                        name: "Quicklooks",
                        file: "images",
                        value: "atr-lidar-ql"
                      },
                      {
                        name: "Profil",
                        file: "database",
                        value: "atr-lidar-profil"
                      },
                      {
                        name: "Bruit",
                        file: "database",
                        value: "atr-lidar-bruit"
                      }
                    ]
                  },
                  {
                    name: "BASTA Radar",
                    value: "bastaradar",
                    file: "images"
                  },
                  {
                    name: "Microphysics",
                    value: "microphysics",
                    file: "images"
                  },
                  {
                    name: "Turbulence",
                    value: "turbulence",
                    file: "images"
                  },
                  {
                    name: "RASTA Radar",
                    value: "rastaradar"
                  },
                  {
                    name: "Picarro",
                    value: "picarro"
                  },
                  {
                    name: "Camera",
                    value: "camera"
                  },
                  {
                    name: "Photos",
                    file: "image",
                    value: "atr-photos"
                  }
                ]
              },
              {
                name: "HALO",
                file: "plane",
                children: [
                  {
                    name: "Reports",
                    file: "txt",
                    value: "halo-reports"
                  },
                  {
                    name: "Photos",
                    file: "image",
                    value: "halo-photos"
                  },
                  {
                    name: "Flight tracks",
                    file: "path",
                    value: "haloflights"
                  },
                  {
                    name: "Unified data",
                    file: "database",
                    value: "halo-unified"
                  },
                  {
                    name: "AVAP Dropsondes",
                    children: [
                      {
                        name: "Quicklooks",
                        file: "images",
                        value: "avap"
                      },
                      {
                        name: "Data",
                        file: "database",
                        value: "avap-data"
                      }
                    ]
                  },
                  {
                    name: "BACARDI",
                    file: "images",
                    value: "bacardi"
                  },
                  {
                    name: "BAHAMAS",
                    file: "images",
                    value: "bahamas"
                  },
                  {
                    name: "HAMP Quicklooks",
                    file: "images",
                    value: "hamp"
                  },
                  {
                    name: "HAMP Radiometer Quicklooks",
                    file: "images",
                    value: "hampradiometer"
                  },
                  {
                    name: "KT-19",
                    file: "images",
                    value: "kt-19"
                  },
                  {
                    name: "SMART",
                    file: "images",
                    value: "smart"
                  },
                  {
                    name: "WALES Lidar",
                    file: "images",
                    value: "walesidar"
                  },
                  {
                    name: "HAMP Cloud Radar",
                    value: "hampradar"
                  },
                  {
                    name: "specMACS",
                    value: "specmacs"
                  },
                  {
                    name: "IR Imager",
                    value: "irimager"
                  }
                ]
              },
              {
                name: "WP-3D Orion",
                file: "plane",
                children: [
                  {
                    name: "Flight level data",
                    file: "database",
                    value: "wp3d-data"
                  },
                  {
                    name: "Dropsonde data",
                    file: "database",
                    value: "wp3d-dropsonde"
                  },
                  {
                    name: "Reports",
                    file: "txt",
                    value: "wp3d-reports"
                  },
                  {
                    name: "Photos",
                    file: "image",
                    value: "wp3d-photos"
                  }
                ]
              },
              {
                name: "BAS Twin-Otter",
                file: "plane",
                children: [
                  {
                    name: "Reports",
                    file: "txt",
                    value: "twin-reports"
                  },
                  {
                    name: "Photos",
                    file: "image",
                    value: "twin-photos"
                  }
                ]
              }
            ]
          },
          {
            name: "Cloud Kite",
            file: "airballoon",
            children: [

              {
                name: "Flight quicklooks",
                file: "images",
                value: "cloudkite"
              },
              {
                name: "MSM89 flight summary",
                file: "txt",
                value: "cloudkite-msm89"
              },
              {
                name: "M161 flight summary",
                file: "txt",
                value: "cloudkite-m161"
              }
            ]
          },
          {
            name: "Boréal UAV",
            file: "drone",
            value: "borealuav"
          },
          {
            name: "Barbados",
            file: "home",
            children: [
              {
                name: "PoldiRad",
                file: "radar",
                children: [
                  {
                    name: "Live",
                    file: "web",
                    value: "poldirad-live"
                  },
                  {
                    name: "Quicklooks (Interactive Map)",
                    file: "images",
                    value: "poldirad-ql"
                  },
                  {
                    name: "Raw data",
                    file: "database",
                    children: [
                      {
                        name: "PPI_PCP",
                        file: "database",
                        value: "poldirad-ppi_pcp"
                      },
                      {
                        name: "PPI_VOL",
                        file: "database",
                        value: "poldirad-ppi_vol"
                      },
                      {
                        name: "RHI_BCO",
                        file: "database",
                        value: "poldirad-rhi_bco"
                      },
                      {
                        name: "RHI_TAR",
                        file: "database",
                        value: "poldirad-rhi_tar"
                      }
                    ]
                  },
                  {
                    name: "Photos",
                    file: "images",
                    value: "poldirad-photos"
                  }
                ]
              },
              {
                name: "BCO soundings quicklooks",
                file: "images",
                value: "bco-soundings"
              },
              {
                name: "BCO soundings NetCDF files",
                file: "database",
                value: "bco-soundings-ftp"
              },
              {
                name: "BCO Picarro",
                file: "database",
                value: "bco-picarro"
              },
              {
                name: "BCO WXT",
                file: "database",
                value: "bco-wxt"
              },
              {
                name: "BCO BackTrajectories",
                children: [
                  {
                    name: "Quicklooks",
                    file: "images",
                    value: "bco-bt-ql"
                  },
                  {
                    name: "Data",
                    file: "database",
                    value: "bco-bt-data"
                  }
                ]
              },
              {
                name: "Ragged Point Observations",
                file: "obs",
                value: "ragged-quicklooks"
                /*
                children: [
                  {
                    name: "Observations - Quicklooks",
                    file: "images",
                    value: "ragged-quicklooks"
                  },
                  {
                    name: "Photos",
                    file: "images",
                    value: "ragged-photos"
                  }
                ]*/
              },
              {
                name: "CORAL Lidar",
                file: "radar",
                value: "coral"
              },
              {
                name: "Reports",
                file: "txt",
                value: "bco-reports"
              },
              {
                name: "BCO",
                file: "home",
                value: "bco"
              }
            ]
          },
          {
            name: "Ships",
            file: "ship",
            children: [
              {
                name: "RV Atalante",
                file: "ship",
                value: "rvatalante",
                children: [
                  {
                    name: "Ships raw data",
                    file: "database",
                    value: "rv-atalante-raw-ships"
                  },
                  {
                    name: "Instruments data",
                    file: "database",
                    children: [
                      {
                        name: "Raw data",
                        file: "database",
                        value: "rv-atalante-raw-instruments"
                      },
                      {
                        name: "NetCDF data",
                        file: "database",
                        value: "rv-atalante-netcdf-instruments"
                      }
                    ]
                  },
                  {
                    name: "Atmospheric mast data",
                    file: "database",
                    value: "rv-atalante-atm-mast"
                  },
                  {
                    name: "Maps SAT Forecast Ocean",
                    file: "images",
                    value: "rv-atalante-maps-sat"
                  },
                  {
                    name: "Soundings",
                    file: "balloon",
                    children: [
                      {
                        name: "Soundings quicklooks",
                        file: "images",
                        value: "rv-atalante-soundingsq"
                      },
                      {
                        name: "Soundings data",
                        file: "database",
                        value: "rv-atalante-soundings"
                      }
                    ]
                  },
                  {
                    name: "Ceilometer",
                    file: "database",
                    value: "rv-atalante-ceilometer"
                  },
                  {
                    name: "ThermoSalinoGraph",
                    file: "database",
                    children: [
                      {
                        name: "TSG (ASCII)",
                        file: "txt",
                        value: "rv-atalante-tsg"
                      },
                      {
                        name: "TSG (NetCDF)",
                        file: "database",
                        value: "rv-atalante-tsg2"
                      }
                    ]
                  },
                  {
                    name: "XBT profiles",
                    file: "database",
                    value: "rv-atalante-prxb"
                  },
                  {
                    name: "CTD profiles",
                    file: "database",
                    value: "rv-atalante-prct"
                  },
                  {
                    name: "Floats",
                    file: "buoy",
                    children: [
                      {
                        name: "Ocarina",
                        file: "database",
                        value: "rv-atalante-ocarina"
                      },
                      {
                        name: "Piccolo",
                        file: "database",
                        value: "rv-atalante-piccolo"
                      }
                    ]
                  },
                  {
                    name: "Visible cloud camera",
                    file: "database",
                    value: "rv-atalante-viscloudcam"
                  },
                  {
                    name: "Thermal cloud camera",
                    file: "database",
                    value: "rv-atalante-thermcloudcam"
                  },
                  {
                    name: "Reports",
                    file: "txt",
                    value: "rv-atalante-reports"
                  },
                  {
                    name: "Photos",
                    file: "image",
                    value: "rv-atalante-photos"
                  }
                ]
              },
              {
                name: "RV Maria S Merian",
                file: "ship",
                value: "rvmaria",
                children: [
                  {
                    name: "Radar & MRR",
                    file: "images",
                    value: "rv-maria-radar"
                  },
                  {
                    name: "Cloud radar",
                    file: "database",
                    value: "rv-maria-cloudradar"
                  },
                  {
                    name: "Ships data",
                    file: "database",
                    value: "rv-maria-data"
                  },
                  {
                    name: "Gliders (IFM03, IFM09, IFM12)",
                    file: "database",
                    value: "rv-maria-glider"
                  },
                  {
                    name: "Drifters",
                    file: "database",
                    value: "rv-maria-drifter"
                  },
                  {
                    name: "ThermoSalinoGraph",
                    file: "database",
                    children: [
                      {
                        name: "TSG (ASCII)",
                        file: "txt",
                        value: "rv-maria-tsg"
                      },
                      {
                        name: "TSG (NetCDF)",
                        file: "database",
                        value: "rv-maria-tsg2"
                      }
                    ]
                  },
                  /*{
                    name: "XBT profiles",
                    file: "database",
                    value: "rv-maria-prxb"
                  },*/
                  {
                    name: "CTD profiles",
                    file: "database",
                    value: "rv-maria-prct"
                  },
                  {
                    name: "CTD",
                    file: "database",
                    value: "rv-maria-ctd"
                  },
                  {
                    name: "UCTD",
                    file: "database",
                    value: "rv-maria-uctd"
                  },
                  {
                    name: "MSS",
                    file: "database",
                    value: "rv-maria-mss"
                  },
                  {
                    name: "MVP",
                    file: "database",
                    value: "rv-maria-mvp"
                  },
                  {
                    name: "Photometer",
                    file: "database",
                    value: "rv-maria-photometer"
                  },
                  {
                    name: "Visible cloud camera",
                    file: "database",
                    value: "rv-maria-viscloudcam"
                  },
                  {
                    name: "Thermal cloud camera",
                    file: "database",
                    value: "rv-maria-thermcloudcam"
                  },
                  {
                    name: "Doppler Lidar",
                    file: "database",
                    value: "rv-maria-doppler"
                  },
                  {
                    name: "Reports",
                    file: "txt",
                    value: "rv-maria-reports"
                  },
                  {
                    name: "Photos",
                    file: "images",
                    value: "rv-maria-photos"
                  }
                ]
              },
              {
                name: "RV Meteor",
                file: "ship",
                value: "rvmeteor",
                children: [
                  {
                    name: "Ship data (DSHIP)",
                    file: "database",
                    value: "meteor-data"
                  },
                  {
                    name: "Soundings",
                    file: "balloon",
                    value: "meteor-soundings"
                  },
                  {
                    name: "Ceilometer",
                    file: "database",
                    value: "meteor-ceilometer"
                  },
                  {
                    name: "Cloud radar",
                    file: "database",
                    value: "meteor-cloudradar"
                  },
                  {
                    name: "Visible cloud camera",
                    file: "database",
                    value: "meteor-viscloudcam"
                  },
                  {
                    name: "Thermal cloud camera",
                    file: "database",
                    value: "meteor-thermcloudcam"
                  },
                  {
                    name: "Licht Raman LIDAR",
                    file: "database",
                    value: "meteor-raman"
                  },
                  {
                    name: "CTD",
                    file: "database",
                    value: "meteor-ctd"
                  },
                  {
                    name: "CTD profiles",
                    file: "database",
                    value: "rv-meteor-prct"
                  },
                  {
                    name: "PAX",
                    file: "database",
                    value: "meteor-pax"
                  },
                  {
                    name: "ADCP",
                    file: "database",
                    value: "meteor-adcp"
                  },
                  {
                    name: "Gliders",
                    file: "database",
                    value: "meteor-gliders"
                  },
                  {
                    name: "ThermoSalinoGraph",
                    file: "database",
                    children: [
                      {
                        name: "TSG (ASCII)",
                        file: "txt",
                        value: "rv-meteor-tsg"
                      },
                      {
                        name: "TSG (NetCDF)",
                        file: "database",
                        value: "rv-meteor-tsg2"
                      }
                    ]
                  },
                  /*{
                    name: "XBT profiles",
                    file: "database",
                    value: "rv-meteor-prxb"
                  },*/
                  {
                    name: "Reports",
                    file: "txt",
                    value: "rv-meteor-reports"
                  }
                ]
              },
              {
                name: "RV Ronald H. Brown ",
                file: "ship",
                value: "rvronald",
                children: [
                  {
                    name: "Aerosol Met",
                    file: "database",
                    value: "rv-rhb-data-aerosol"
                  },
                  {
                    name: "Soundings",
                    file: "balloon",
                    children: [
                      {
                        name: "Soundings - Quicklooks",
                        file: "images",
                        value: "rv-rhb-soundings"
                      },
                      {
                        name: "Soundings - Data",
                        file: "database",
                        value: "rv-rhb-data-radiosonde"
                      }
                    ]
                  },
                  {
                    name: "ThermoSalinoGraph",
                    file: "database",
                    children: [
                      {
                        name: "TSG (ASCII)",
                        file: "txt",
                        value: "rv-rhb-tsg"
                      },
                      {
                        name: "TSG (NetCDF)",
                        file: "database",
                        value: "rv-rhb-tsg2"
                      }
                    ]
                  },
                  /* {
                    name: "XBT profiles",
                    file: "database",
                    value: "rv-rhb-prxb"
                  },
                  {
                    name: "CTD profiles",
                    file: "database",
                    value: "rv-rhb-prct"
                  },*/
                  {
                    name: "Lidar",
                    file: "database",
                    value: "rv-rhb-data-lidar"
                  },
                  {
                    name: "Radar",
                    file: "database",
                    value: "rv-rhb-data-radar"
                  },
                  {
                    name: "Ceilometer",
                    file: "database",
                    value: "rv-rhb-data-ceilometer"
                  },
                  {
                    name: "Flux",
                    file: "database",
                    value: "rv-rhb-data-flux"
                  },
                  {
                    name: "Data Plots from PMEL Aerosol Group",
                    file: "images",
                    value: "rv-rhb-web"
                  },
                  {
                    name: "Reports",
                    file: "txt",
                    value: "rv-rhb-reports"
                  }
                ]
              },
              {
                name: "Marine traffic",
                file: "map",
                value: "marine-traffic"
              }
            ]
          },
          {
            name: "Autonaut & gliders",
            file: "saildrone",
            children: [
              {
                name: "Caravela",
                file: "database",
                value: "caravela"
              },
              {
                name: "CMEMS - PRGL Glider",
                value: "prgl"
              },
              {
                name: "UEA - sg579 Glider",
                value: "sg579"
              },
              {
                name: "UEA - sg620 Glider",
                value: "sg620"
              },
              {
                name: "UEA - sg637 Glider",
                value: "sg637"
              },
              {
                name: "RV Meteor Gliders",
                file: "database",
                value: "meteor-gliders"
              }
            ]
          },
          {
            name: "Buoys and floats",
            file: "buoy",
            children: [
              {
                name: "TRUSTED (NKE)",
                file: "database",
                value: "buoy-nke"
              },
              {
                name: "SVP-BS (NKE)",
                file: "database",
                value: "buoy-svp-bs"
              },
              {
                name: "SVP-BSW (NOAA)",
                file: "database",
                value: "buoy-svp-bsw"
              },
              {
                name: "Surpact",
                file: "database",
                value: "buoy-surpact"
              },
              {
                name: "CMEMS - ARGO floats (PRPF)",
                file: "database",
                value: "buoy-prpf"
              },
              {
                name: "CMEMS - Drifting buoys (TSDB)",
                file: "database",
                value: "buoy-tsdb"
              },
              {
                name: "CMEMS - Currents from drifting buoys (TSDC)",
                file: "database",
                value: "buoy-tsdc"
              }
              /*,
              {
                name: "CMEMS - Thermosalinograph (TSTS)",
                file: "database",
                value: "buoy-tsts"
              }*/
            ]
          },
          {
            name: "Saildrones",
            file: "saildrone",
            children: [
              {
                name: "NOAA - Saildrones",
                file: "database",
                value: "saildrones-noaa"
              },
              {
                name: "ATOMIC - Saildrones",
                file: "database",
                children: [
                  {
                    name: "All data",
                    file: "database",
                    value: "saildrones-alldata"
                  },
                  {
                    name: "Data by day",
                    file: "database",
                    value: "saildrones-data"
                  }
                ]
              },
              {
                name: "CMEMS - TSSD Saildrone ",
                file: "database",
                value: "saildrones-tssd"
              },
              {
                name: "Saildrone website",
                file: "web",
                value: "saildrones-website"
              }
            ]
          }
        ]
      },
      {
        name: "Forecasts",
        file: "model",
        children: [
          {
            name: "Global",
            file: "model",
            children: [
              {
                name: "ECMWF - Surface",
                file: "images",
                value: "obs-model-ecmwf-precip"
              },
              {
                name: "ECMWF - Profiles",
                file: "images",
                value: "obs-model-ecmwf-pt"
              },
              {
                name: "ARPEGE - Surface",
                file: "images",
                value: "obs-model-arpege-cape"
              },
              {
                name: "ARPEGE - Pressure level",
                file: "images",
                value: "obs-model-arpege-pfcc"
              },
              {
                name: "ARPEGE - Profiles",
                file: "images",
                value: "obs-model-arpege-pz"
              },
              {
                name: "DWD - Surface",
                file: "images",
                value: "obs-model-dwd-surface"
              },
              {
                name: "DWD - Pressure level",
                file: "images",
                value: "obs-model-dwd-pressure"
              },
              {
                name: "DWD - Profiles",
                file: "images",
                value: "obs-model-dwd-pz"
              },
              {
                name: "GFS - Surface",
                file: "images",
                value: "obs-model-gfs-surface"
              },
              {
                name: "GFS - Pressure level",
                file: "images",
                value: "obs-model-gfs-pressure"
              },
              {
                name: "GFS - Profiles",
                file: "images",
                value: "obs-model-gfs-profile"
              },
              {
                name: "LMDZ - Surface",
                file: "images",
                value: "obs-model-lmdz-surface"
              },
              {
                name: "LMDZ - Pressure level",
                file: "images",
                value: "obs-model-lmdz-pressure"
              },
              {
                name: "UK Met Office - Surface",
                file: "images",
                value: "obs-model-mo-surface"
              },
              {
                name: "UK Met Office - Pressure level",
                file: "images",
                value: "obs-model-mo-pl"
              }
            ]
          },
          {
            name: "Regional",
            file: "model",
            children: [
              {
                name: "AROME 2.5km - Surface",
                file: "images",
                value: "obs-model-arome25-map2d"
              },
              {
                name: "AROME 2.5km - Pressure level",
                file: "images",
                value: "obs-model-arome25-map2d-pl"
              },
              {
                name: "AROME 2.5km - Time evolution",
                file: "images",
                value: "obs-model-arome25-evol"
              },
              {
                name: "AROME 2.5km - Profiles",
                file: "images",
                value: "obs-model-arome25-p"
              },
              {
                name: "AROME 1.3km - Surface",
                file: "images",
                value: "obs-model-arome13-map2d"
              },
              {
                name: "AROME 1.3km - Pressure level",
                file: "images",
                value: "obs-model-arome13-map2d-pl"
              },
              {
                name: "AROME 1.3km - Time evolution",
                file: "images",
                value: "obs-model-arome13-evol"
              },
              {
                name: "AROME 1.3km - Profiles",
                file: "images",
                value: "obs-model-arome13-p"
              },
              {
                name: "HARMONIE - Surface",
                file: "images",
                value: "obs-model-harmonie"
              },
              {
                name: "HARMONIE - Pressure level",
                file: "images",
                value: "obs-model-harmonie-pl"
              },
              /*{
                name: "ICON",
                file: "image",
                value: "obs-model-icon"
              },*/
              {
                name: "ICON - Surface",
                file: "images",
                value: "obs-model-icon-surface"
              },
              {
                name: "ICON - Pressure level",
                file: "images",
                value: "obs-model-icon-pressure"
              },
              {
                name: "ICON - Profiles",
                file: "images",
                value: "obs-model-icon-profiles"
              },
              {
                name: "UK Met Office 2km - Surface",
                file: "images",
                value: "obs-model-mo2-surface"
              },
              {
                name: "UK Met Office 2km - Pressure level",
                file: "images",
                value: "obs-model-mo2-pl"
              },
              {
                name: "UK Met Office 4km - Surface",
                file: "images",
                value: "obs-model-mo4-surface"
              },
              {
                name: "UK Met Office 4km - Pressure level",
                file: "images",
                value: "obs-model-mo4-pl"
              }
            ]
          },
          {
            name: "Atm. model profiles comparison",
            file: "model",
            value: "obs-model-p-comp"
          },
          {
            name: "Ocean",
            file: "model",
            children: [
              {
                name: "Hycom Forecast Maps",
                file: "images",
                value: "obs-model-hycom-maps"
              },
              {
                name: "Mercator Forecast Maps",
                file: "images",
                value: "obs-model-mercator-maps"
              },
              {
                name: "Hycom Forecast Section",
                file: "images",
                value: "obs-model-hycom-section"
              },
              {
                name: "Mercator Forecast Section",
                file: "images",
                value: "obs-model-mercator-section"
              },
              {
                name: "Map of Sections for forecasts",
                file: "images",
                value: "obs-model-maps-sections"
              }
            ]
          },
          {
            name: "ETH Forecast website",
            file: "web",
            value: "eth"
          },
          {
            name: "UK Met Office Forecast website",
            file: "web",
            value: "uk-mo"
          }
        ]
      },
      {
        name: "Reports",
        file: "txt",
        value: "reports"
      },
      {
        name: "Products",
        file: "toolbox",
        children: [
          {
            name: "GOES-E movies",
            file: "movies",
            children: [
              {
                name: "Visible",
                file: "movies",
                value: "movies-vis"
              },
              {
                name: "Infrared",
                file: "movies",
                value: "movies-infra"
              }
            ]
          },
          {
            name: "Radiative Profiles",
            file: "database",
            value: "radiative-profiles"
          },
          {
            name: "Platform tracks",
            file: "database",
            value: "tracks"
          }
        ]
      },
      {
        name: "Services and Software",
        file: "apps",
        children: [
          {
            name: "Thredds Service",
            file: "application",
            value: "thredds"
          },
          {
            name: "Dropsondes movies code",
            file: "github",
            value: "dropsondes-code"
          }
        ]
      },
      {
        name: "Outreach & Symposium",
        file: "school",
        children: [
          {
            name:
              "Elucidating the role of Clouds and ocean-atmosphere interactions in circulations and climate",
            file: "presentation",
            value: "presentation"
          },
          {
            name: "Symposium presentations",
            file: "txt",
            value: "symposium"
          }
        ]
      },
      {
        name: "Photo Gallery",
        file: "image",
        value: "photo"
      }
      /*,
      {
        name: "Logistics",
        file: "dolly",
        value: "logistics"
      },
      {
        name: "Other data & information",
        file: "database",
        value: "database"
      }*/
    ]
  }),
  methods: {
    openContent(c) {
      this.content = c;
    }
  },
  created() {},
  mounted() {
    let uri = window.location.toString();
    if (uri.indexOf("#/") > 0) {
      let s = uri.substring(uri.indexOf("#/") + 2);
      if (s != "") this.openContent(s);
    }
  }
};
</script>

<style>
.v-treeview--dense .v-treeview-node__root {
  min-height: 32px;
}
</style>
